import { Routes, Route } from 'react-router-dom';
import List from './index';
import CreateCustomer from './Create';
import CustomerDetail from './Detail';
import EditCustomer from './Edit';

export default function CustomersModule() {
  return (
    <Routes>
      <Route path="/" element={<List />} />
      <Route path="/create" element={<CreateCustomer />} />
      <Route path="/detail/:id" element={<CustomerDetail />} />
      <Route path="/edit/:id" element={<EditCustomer />} />
    </Routes>
  );
} 